import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"



// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager  } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import {  IFilter } from '@syncfusion/ej2-angular-grids';
import {  ToolbarItems, GroupSettingsModel,
RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap';
import { Location } from '@angular/common';
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';


@Component({
  selector: 'app-timeframe-surcharges',
  templateUrl: './timeframe-surcharges.component.html',
  styleUrls: ['./timeframe-surcharges.component.scss']
})
export class TimeframeSurchargesComponent implements OnInit {
  modalRef: any;

    // for grid so it has change events.
    public data: Observable<DataStateChangeEventArgs>;
    public state: DataStateChangeEventArgs;
    @ViewChild('grid')
    public grid: GridComponent;
   
    public pageSettings: Object;
    public pageOptions = { pageSize: 100 }; 
    public filterOptions: FilterSettingsModel;
    public formatOptions: any;
    // public filterOptions: FilterSettingsModel;
    public filter : IFilter;
    public toolbarOptions: ToolbarItems[] | object;
    public groupOptions: GroupSettingsModel;
    public templateOptionsDate: IFilterUI;
    public elem1: HTMLElement;
    public datePickerObj: DatePicker;
    initialPage: { pageSize: number; };
    dateFormat: string;
  count: any;
  initialCount: any;
  subject_service_types: Object;
  timeframe_surcharges: Object;

  constructor(
      private http: HttpClient, private _demoService: DemoService,
        private route: ActivatedRoute, public toastr: HotToastService,
         vcr: ViewContainerRef, private router: Router,
         private modalService: BsModalService, viewRef: ViewContainerRef,
         private _location: Location,  public gfunc: GlobalFunctionsService
  ) { }

  ngOnInit(): void {

    this.getTimeframeSurcharges();


// Setup Grid
this.toolbarOptions = ['Search'];
// this.toolbarOptions = ['ExcelExport', 'Search'];
// this.toolbar = [
// { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

//  this.initialPage = { pageSize: 100 };
this.filterOptions = {
  type: 'Menu'
};
this.groupOptions = { columns: ['subject_service_type_id'] }; // sets auto grouping for the grid
this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
this.dateFormat = 'dd/MM/yyyy hh:mm a';
this.filter = { params: { format: this.dateFormat } };

    
  }











// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
//   if (args.item.id === 'Click') {

//   //  this.grid.showSpinner();

//   //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
//  //  console.log(args.data.items);
 


//   let pdfdata;
//   const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
//   for (let i = 0; i < query.queries.length; i++) {
//     if (query.queries[i].fn === 'onPage') {
//       query.queries.splice(i, 1);       // remove page query to get all records
//       break;
//     }
//   }
//   const fdata = new DataManager({ json: this.logs }).executeQuery(query).then((e: any) => {
//     pdfdata = e.result as object[];  // get all filtered records
//     const exportProperties = {
//       dataSource: pdfdata,
//     };
//     // console.log(pdfdata.results);
    
//    // this.search_results = pdfdata.records; // need this if a grouping is set.
// /*     this.search_results = pdfdata;
//     this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
//     this.toastr.success( "Press Start To Process Que");  */
//    // this.grid.pdfExport(exportProperties);
//   }).catch((e) => true);
//   }

//  //  this.grid.hideSpinner();

}



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
  this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


refreshGrid() { // refresh the databutton
  // this.getFiles();
 this.getTimeframeSurcharges()
  this.grid.refresh();
};
   // to router navigate back
   public goBack() {
    this._location.back();
    }




 sendTypeID(id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.count = id;
  this.initialCount = id;
// console.log('sending ID:' + this.count);

}


deleteJobType(job_type_id) {
  if (confirm('Are you sure you want to delete ' + '?... This cannot be undone!')) {
    this._demoService.deleteJobType(job_type_id).subscribe(
       data => {
         // refresh the list
         this.toastr.warning("Data Object Deleted!")
         this.refreshGrid();
         return true;
       },
       error => {
         console.error('Error deleting!');
        return console.log(error);
       }
    );
}
};



deleteTimeframeSurcharge(job_type_id) {
  if (confirm('Are you sure you want to delete ' + '?... This cannot be undone!')) {
    // this._demoService.deleteJobType(job_type_id).subscribe(
    //    data => {
    //      // refresh the list
    //      this.toastr.warning("Data Object Deleted!")
    //      this.refreshGrid();
    //      return true;
    //    },
    //    error => {
    //      console.error('Error deleting!');
    //     return console.log(error);
    //    }
    // );
}
};




getTimeframeSurcharges() {
  this._demoService.getTimeframeSurcharges().subscribe(
     data => { this.timeframe_surcharges = data;  },
     err => console.error(err),
      () => {
        // console.log('done loading Subject Service Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }



}
